import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getAllAttorney,
  searchAttorney,
  deleteAttorney,
} from "../../api/server";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import PaginatedItems from "./pagination";
import * as Yup from "yup";
import { ThreeDots } from "react-loader-spinner";
import DeleteModal from "../../common/deleteModal";
import gladeBadge from "../../assets/images/glade-badge.png";
import "./manage-attorney.css";

const validationSchema = Yup.object({
  search: Yup.string().required("Name/Email is required"),
});

const ManageAttorney = () => {
  const navigate = useNavigate();
  const [response, setResponse] = useState();
  const [getloading, setGetLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [activeSearch, setActiveSearch] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [pageCache, setPageCache] = useState({});
  const [searchCache, setSearchCache] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState();

  const { handleChange, touched, values, errors, handleSubmit, resetForm } =
    useFormik({
      initialValues: { search: "" },
      validationSchema: validationSchema,
      onSubmit: (values) => {
        if (searchCache[pageNo]) {
          // Data already in cache, no need for API call
          const { cachedResponse, cachedTotal } = searchCache[pageNo];
          setResponse(cachedResponse);
          setTotal(cachedTotal);
        } else {
          setFilterLoading(true);
          setGetLoading(true);
          searchAttorney(pageNo, values)
            .then((res) => {
              setActiveSearch(true);
              const newData = res.data.data.result;
              const newTotal = res.data.data.total;
              setSearchCache((prevCache) => ({
                ...prevCache,
                [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
              }));
              setResponse(newData);
              setTotal(newTotal);
              if (pageNo === 1) toast.success("Attorney search successful");
              setFilterLoading(false);
              setGetLoading(false);
            })
            .catch((err) => {
              toast.error(err.response.data.error);
              setFilterLoading(false);
              setGetLoading(false);
            });
        }
      },
    });

  const handlePageChange = () => {
    if (activeSearch) handleSubmit(values.search);
  };

  const handleClearFilters = () => {
    const { cachedResponse, cachedTotal } = pageCache[pageCache.pageNo];
    setPageNo(pageCache.pageNo);
    setActiveSearch(false);
    setTotal(cachedTotal);
    setSearchCache({});
    setResponse(cachedResponse);
    resetForm();
    toast.success("Attorney search cleared");
  };

  useEffect(() => {
    const fetchData = async () => {
      if (pageCache[pageNo]) {
        // Data already in cache, no need for API call
        const { cachedResponse, cachedTotal } = pageCache[pageNo];
        setResponse(cachedResponse);
        setTotal(cachedTotal);
      } else {
        setGetLoading(true);
        try {
          const res = await getAllAttorney(pageNo);
          const newData = res.data.data.result;
          const newTotal = res.data.data.count;

          // Update the cache with new data
          setPageCache((prevCache) => ({
            ...prevCache,
            [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
          }));

          // Set state with new data
          setResponse(newData);
          setTotal(newTotal);
        } catch (err) {
          toast.error(err.response.data.error);
        } finally {
          setGetLoading(false);
        }
      }
    };
    if (!activeSearch) {
      fetchData();
    }
  }, [pageNo, pageCache]);

  const hanldeDeleteAttorney = async (id) => {
    setDeleteLoading(true);
    await deleteAttorney(
      id,
      response.length > 1 ? pageNo : pageNo - 1 > 0 ? pageNo - 1 : pageNo
    )
      .then((res) => {
        const newData = res.data.data.result;
        const newTotal = res.data.data.count;
        setResponse(newData);
        setTotal(newTotal);
        setPageCache({
          [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
        });
        if (activeSearch) {
          setPageNo(1);
        } else {
          setPageNo(response.length > 1 ? pageNo : pageNo - 1);
        }
        setActiveSearch(false);
        setSearchCache({});
        resetForm();
        setDeleteUser("");
        toast.success("Student deleted successfully");
        setDeleteLoading(false);
      })
      .catch((err) => {
        setDeleteUser("");
        toast.error(err.response.data.error);
        setDeleteLoading(false);
      });
  };

  return (
    <div>
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content" className="attorney-list-page">
          <DashboardNavbar />
          {/* <DeleteModal
            loading={deleteLoading}
            showModal={deleteUser}
            setDelete={setDeleteUser}
            handleSubmit={() => {
              hanldeDeleteAttorney(deleteUser);
            }}
          /> */}
          {/* <!-- Page Content Holder --> */}
          <section className="manage-students">
            <h1 className="attorney-list-heading">Manage Attorney</h1>
            <div className="card">
              <div className="card-header">
                <div className="attorney-list-toolbar">
                  <div className="attorney-list-buttons">
                    <div className="attorney-list-actions">
                      <button
                        className="btn_brnd"
                        onClick={() => {
                          navigate("/setupattorneyaccount");
                        }}
                      >
                        Set-up Attorney
                      </button>
                      <button
                        className="btn_brnd"
                        onClick={() => {
                          navigate("/managecouponcodes");
                        }}
                      >
                        Manage Attorney Codes
                      </button>
                    </div>
                  </div>
                  <div className="attorney-list-search">
                    <form onSubmit={handleSubmit}>
                      <div className="table-search">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          style={{ paddingRight: "35px" }}
                          onChange={handleChange}
                          name="search"
                          value={values.search}
                        />
                        <button
                          disabled={filterLoading || getloading}
                          type="submit"
                          aria-label="Search attorneys"
                          onClick={() => {
                            setPageCache((prevCache) => ({
                              ...prevCache,
                              pageNo: pageNo,
                            }));
                            setPageNo(1);
                            setSearchCache({});
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                      {errors.search && touched.search ? (
                        <p className="text-danger">{errors.search}</p>
                      ) : null}
                      {activeSearch && (
                        <button
                          className="btn_brnd mt-3 me-3 flex"
                          type="button"
                          onClick={handleClearFilters}
                        >
                          Clear Search
                        </button>
                      )}
                    </form>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="attorney-table-scroll" role="region" aria-label="Attorney list" tabIndex={0}>
<table className="table attorney-list-table">
                  <colgroup><col style={{ width: "28%" }} /><col style={{ width: "34%" }} /><col style={{ width: "15%" }} /><col style={{ width: "11%" }} /><col style={{ width: "7%" }} /><col style={{ width: "5%" }} /></colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Code</th>
                      <th scope="col">Clients</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {getloading ? (
                      <tr>
                        <td colSpan={6}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : response && response.length > 0 ? (
                      response.map((user, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {user.firstname.replace("&amp;", "&")}
                            {String(user?.source || "").toLowerCase() ===
                              "glade" && (
                              <img
                                className="glade-source-badge attorney-glade-source-badge"
                                src={gladeBadge}
                                alt="Glade"
                                title="Glade attorney"
                              />
                            )}
                          </th>
                          <td style={{ textTransform: "none" }}>
                            {user?.email}
                          </td>
                          <td
                            style={{
                              textTransform: "none",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {user?.phone}
                          </td>
                          <td style={{ textTransform: "none" }}>
                            {user?.code}
                          </td>
                          <td>
                            <Link
                              // to={`/attorney-clients?attorney=${user.firstname.replace(
                              //   /&/g,
                              //   "-"
                              // )}`}
                               to={`/attorney-clients?attorney=${encodeURIComponent(user.firstname)}`}
                              style={{ color: "black" }}
                            >
                              View
                            </Link>
                          </td>
                          <td>
                            <div className="action-btns"style={{justifyContent:'center'}}>
                              {/* <button
                                className="btn-delete"
                                onClick={() => {
                                  setDeleteUser(user.id);
                                }}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button> */}
                              <Link to={`/edit-attorney?id=${user.id}`}>
                                <button className="btn-edit">
                                  <i className="fa-regular fa-pen-to-square"></i>
                                </button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>No attorney found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
</div>
                {!filterLoading && !getloading && total !== undefined && (
                  <footer className="attorney-list-footer">
                  <span>{total > 0 ? `Showing ${(pageNo - 1) * 50 + 1}–${Math.min((pageNo - 1) * 50 + (response?.length || 0), total)} of ${total}` : "Showing 0 of 0"}</span>
                  {total > 50 && <PaginatedItems
                    responsive
                    total={total}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    handlePageChange={handlePageChange}
                  />}
                  </footer>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ManageAttorney;
